/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: var(--nve-ref-size-200);
  --font-size: var(--nve-ref-font-size-100);
  --height: 100px;
  --width: 100%;
  --min-height: 100px;
  --background: var(--nve-sys-interaction-field-background);
  --color: var(--nve-sys-interaction-field-color);
  --border-radius: var(--nve-ref-border-radius-sm);
  --cursor: text;
  --border: 0;
  display: block;
  width: 100%;
  contain: layout;
}

::slotted(textarea) {
  padding: var(--padding) !important;
  font-size: var(--font-size) !important;
  margin: 0 !important;
  align-content: stretch !important;
  background: var(--background) !important;
  border: var(--border) !important;
  color: var(--color) !important;
  border-radius: var(--border-radius) !important;
  cursor: var(--cursor) !important;
}

::slotted(textarea:not([rows])) {
  min-height: var(--min-height) !important;
  height: var(--min-height) !important;
}

::slotted(textarea:not([cols])) {
  width: var(--width) !important;
}

:host([layout*='horizontal']) ::slotted(label) {
  padding-block-start: var(--nve-ref-size-100) !important;
  align-self: start !important;
}

:host([layout*='horizontal']) slot[name='label'] {
  align-self: start;
}

:host([status='error']),
:host(:state(invalid)),
:host(:state(error)) {
  --border: var(--nve-ref-border-width-md) solid var(--nve-sys-support-danger-emphasis-color);
}

:host([status='success']),
:host(:state(success)) {
  --border: var(--nve-ref-border-width-md) solid var(--nve-sys-support-success-emphasis-color);
}

:host(:state(disabled)) {
  --border: var(--nve-ref-border-width-md) solid transparent;
}
